var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showInstallments
    ? _c("div", [
        _c("div", { class: _vm.$x["installment-selector"] }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "align-items": "center",
                "accent-color": "#7123d9",
              },
            },
            [
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.useInstallments,
                      expression: "useInstallments",
                    },
                  ],
                  staticStyle: {
                    display: "block",
                    height: "20px",
                    width: "20px",
                    "margin-right": "10px",
                  },
                  attrs: { type: "checkbox", id: "installmentCbx" },
                  domProps: {
                    checked: Array.isArray(_vm.useInstallments)
                      ? _vm._i(_vm.useInstallments, null) > -1
                      : _vm.useInstallments,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.useInstallments,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.useInstallments = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.useInstallments = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.useInstallments = $$c
                      }
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "font-size": "16px" } }, [
                _vm._v(_vm._s(_vm.label)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("ns-select", {
                class: _vm.$x["select"],
                attrs: {
                  disabled: !_vm.useInstallments,
                  items: _vm.installmentOptions,
                  name: "installmentSelect",
                  height: "500",
                },
                model: {
                  value: _vm.selectedInstallment,
                  callback: function ($$v) {
                    _vm.selectedInstallment = $$v
                  },
                  expression: "selectedInstallment",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        !!_vm.installmentMessage
          ? _c("div", { class: _vm.$x["installment-message"] }, [
              _vm._v("\n        " + _vm._s(_vm.installmentMessage) + "\n    "),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }